
export function button2_click(event) {
	if ($w('#input1').value === 'science'){
	//	$w('#vectorImage2').hide();
	//	$w('#vectorImage1').show();
		$w('#box2').show();
}
else if ($w('#input1').value === 'יצאנו'){
		
		$w('#box2').show();
}
	//else
	//		$w('#vectorImage2').show();


}